type TurnCycleLike = {
  diceOrigins?: number[];
  dice?: number[];
  rollCount: number;
  lastRoll?: {
    indices?: number[];
    rollIndex?: number;
  } | null;
};

export function resolveLastRollIndex(turnCycle: TurnCycleLike): number | undefined {
  if (typeof turnCycle.lastRoll?.rollIndex === 'number') return turnCycle.lastRoll.rollIndex;
  if (turnCycle.rollCount > 0) return turnCycle.rollCount - 1;
  return undefined;
}

export function createIsCurrentRollDie(turnCycle: TurnCycleLike): (idx: number) => boolean {
  const lastRollIndex = resolveLastRollIndex(turnCycle);
  const lastRollIndices = turnCycle.lastRoll?.indices || [];
  const lastRollIndexSet = lastRollIndices.length > 0 ? new Set(lastRollIndices) : null;

  return (idx: number) => {
    if (turnCycle.diceOrigins && typeof lastRollIndex === 'number') {
      const origin = turnCycle.diceOrigins[idx];
      return typeof origin === 'number' ? origin === lastRollIndex : true;
    }
    if (lastRollIndexSet) return lastRollIndexSet.has(idx);
    return true;
  };
}

export function getCurrentRollIndices(
  turnCycle: TurnCycleLike,
  capturedMask?: boolean[],
): number[] {
  const isCurrentRollDie = createIsCurrentRollDie(turnCycle);
  const dice = turnCycle.dice || [];
  const result: number[] = [];
  for (let i = 0; i < dice.length; i++) {
    if (isCurrentRollDie(i) && (!capturedMask || !capturedMask[i])) {
      result.push(i);
    }
  }
  return result;
}
